<template>
  <div
    class="app-side-tool animated"
    :class="{ fadeInRight: visible }"
    v-if="visible"
  >
    <el-popover
      ref="popover"
      placement="left"
      width="180"
      trigger="hover"
    >
      <img
        src="~@/assets/images/appointment_code.png"
        alt="预约咨询二维码"
      >
      <p class="tc">微信扫码预约</p>
    </el-popover>
    <div class="tool-item bg-green">
      <span v-popover:popover>预约咨询</span>
    </div>
    <div
      class="tool-item bg-gray"
      @click="scrollToTop"
    >
      <div>
        <p
          class="iconfont icon-triangle_up_fill"
          style="font-size:2em;margin-top: -6px"
        ></p>
        <p style="margin-top: -8px">TOP</p>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'utils/util'

const showToolTop = 500
const scrollDebounce = debounce()

export default {
  name: 'app-side-tool',
  data() {
    return {
      visible: true
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    handleScroll() {
      const scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop

      scrollDebounce(() => {
        this.visible = scrollTop > showToolTop
      })
    }
  },
  mounted() {
    document.addEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang='less' scoped>
@import '~variables.less';
@tool-item-size: 50px;

.app-side-tool {
  position: fixed;
  z-index: 99;
  top: 50%;
  right: 20px;
  display: flex;
  flex-direction: column;
  font-size: 14px;

  .tool-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    width: @tool-item-size;
    height: @tool-item-size;
    line-height: 1.4;
    text-align: center;
    color: #fff;
    &:hover {
      cursor: pointer;
    }

    &.bg-green {
      background-color: @color-green;
    }
    &.bg-gray {
      background-color: @color-gray;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app-side-tool.vue